"use strict";

var DataObject = require('../DataObject');

//Records a search request submitted by a user (used for statistics)
var Search = DataObject.createDataType({
	init: function(json) {
		this.timestamp = Date.now();
		if (json) {
			this.fromJSON(json);
		}
	},

	id: null,
	searchParams: null,
	userId: null,  //ID of the user who submitted the search
	subscriptionId: null  //subscription ID (if any) of the user who submitted the search
});

module.exports = Search;